import { NavLink } from 'react-router-dom';
import styled, { css } from 'styled-components';
import { em } from 'polished';
import { colors, isDefaultThemeMode } from 'core/theme';
import { media } from 'core/layout';


export const StyledListWraper = styled.div`
    margin-bottom: 3em;
    margin-top: 4em;

   
    border-bottom: 1px solid ${colors.hairline};
    > div {
      margin:-24px 0 24px -3em;

      > div {
        padding: 0 0 0 3em;
        font-size: ${em(18)};
        color: ${colors.text};
        ${media.tabletSmall`
        font-size: 0.9375rem;
        `};
      }
    }

    ${media.tablet`
     
      margin-bottom: 2em;
      margin-top: 1em;

      & > div {
        display: block;
        margin-bottom: 0.75em;
        margin-right: 0 !important;
      }
    `};

   

`;

export const StyledListDiv = styled.div`
    display:flex;
    flex-direction:row;
    width: 100%;

   
    margin-top: 0;
    padding: 0;
    margin-bottom: 1em;

    & > a {
      outline-offset: -2px;
    }
`;

export const StyledNr = styled.span`
  display:inline-block;
  padding:0em 0em 0em 0.5em;

   ${media.tablet`
      padding:0em 0em 0em 0em;
    `};


    ${media.tabletSmall`
      padding:0em 0em 0em 0.5em;
    `};
`;



export const StyledList = styled.ol`
    font-size: ${em(18)};
    color: ${colors.text};
    margin-bottom: 3em;
    margin-top: 0;
    padding: 0 0.5em 0.5em 0em;
    border-bottom: 1px solid ${colors.hairline};

    ${({length}) => length > 2 && css`
      column-count: 2;
      column-gap: 3em;
    `};

    counter-reset: subpage;

    & > li {
        display: inline-block;
        margin-bottom: 1em;
        padding: 0.2em 0.2em 0.2em 1.25em;
        width: 100%;

        counter-increment: subpage;
        position: relative;

        ${({ length }) => length <= 2 && css`
          &:not(:last-child) {
            margin-right: 3em;
          }
        `};

        &:before {
          content: counter(subpage) '. ';
          position: absolute;
          transform: translateX(-100%);
        }

        & > a {
          outline-offset: -2px;
        }
    }

    ${media.tablet`
      column-count: 1;
      column-gap: 0;
      margin-bottom: 2em;
      margin-top: 1em;

      & > li {
        display: block;
        margin-bottom: 0.75em;
        margin-right: 0 !important;
      }
    `};

    ${media.tabletSmall`
      font-size: 0.9375rem;
    `};
`;

export const StyledNavLink = styled(NavLink)`
    color: ${colors.primary} !important;
    display: inline-block;
    vertical-align: top;
    padding: 0.2em 0.5em;
    margin-top: -0.2em;

    &:hover {
        color: ${colors.primaryLight} !important;

        ${(props) => !isDefaultThemeMode(props) && css`
            outline: 2px dashed ${colors.text};
        `};
    }

    ${({isActive}) => isActive() && css`
        color: ${colors.text} !important;
        pointer-events: none;
        text-decoration: none;

        ${(props) => !isDefaultThemeMode(props) && css`
            background-color: ${colors.text};
            color: ${colors.background} !important;
        `};
    `};
`;



// WEBPACK FOOTER //
// ./src/pages/Raksts/components/Apaksraksti/styled.js